import RespetoValoresPrincipiosDto from '../domain/RespetoValoresPrincipiosDto'

export default class UpdateRespetoValoresPrincipios {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(respetoValoresPrincipios) {
    const payload = RespetoValoresPrincipiosDto.update(respetoValoresPrincipios)

    await this.#repository.update(payload, respetoValoresPrincipios.detalle.idEvaluado, respetoValoresPrincipios.id)
    await this.#repository.updateEstatus(
      { fk_idCatEstatusEvaluacion: payload.fk_idCatEstatusEvaluacion },
      respetoValoresPrincipios.detalle.idEvaluado,
      respetoValoresPrincipios.id
    )
  }
}
